<template>
    <transition name="modal">
        <div class="modal-mask" @click="openModal">
            <div class="modal-wrapper">
                <div class="modal-container-form" @click.stop>
                    <div class="modal-header">
                        <slot name="cross">
                            <v-icon style="float: right; top: 0.3vh;" @click="openModal">mdi-close</v-icon>
                        </slot>
                        <slot name="header"> {{ alarm.alarm_name }} </slot>
                    </div>

                    <div class="modal-body">
                        <div class="instructions">
                            {{ alarm.instructions }}
                        </div>
                        <div class="progress">
                            <ul class="checkboxes">
                                <li v-for="(question, index) in alarm.progress_form['check boxes']" :key="index"
                                    style="font-size: 2vmax;">
                                    {{ index }}
                                    <v-radio-group v-model="checkBoxQuestions[index]">
                                        <v-radio v-for="(enonce, i) in question" :label="enonce" :value="enonce"
                                            :key="i"></v-radio>
                                    </v-radio-group>
                                </li>
                            </ul>
                            <div class="multipleChoices">
                                <div v-for="(data, question) in alarm.progress_form['multiple Choice field']"
                                    :key="question" class="question">
                                    <div style="white-space: nowrap;"> {{ question }} </div>
                                    <v-checkbox v-for="(option, index) in data" :key="index" :label="option"
                                        :value="option" v-model="multipleChoiceQuestions[question]"></v-checkbox>
                                </div>
                            </div>
                            <div class="textField">
                                <div v-for="(question, index) in alarm.progress_form['open field (text)']" :key="index">
                                    <div> {{ question }}</div>
                                    <v-text-field label="" outlined v-model="textField[question]"></v-text-field>
                                </div>

                            </div>
                            <div class="numberField">
                                <div v-for="(question, index) in alarm.progress_form['open field (Number)']"
                                    :key="index">
                                    <div> {{ question }}</div>
                                    <v-text-field label="" outlined
                                        :rules="[value => value !== undefined && value.split('.').length < 3 || 'Invalid Format']"
                                        v-model="numberField[question]"
                                        onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))" />
                                    <p v-if="!validNumber[question]"
                                        style="color: crimson; font-size: 1.6vmax; margin: 0;">{{ $t('_invalid_format_')
                                        }}</p>
                                </div>
                            </div>
                            <div class="attachFiles" v-if="this.attachFiles !== ''">
                                <input v-if="this.attachFiles === 'Picture'" capture="environment" accept="image/*"
                                    id="input1" multiple type="file" @change="handleFileChange">
                                <input v-else id="input1" accept="text/csv" multiple type="file"
                                    @change="handleFileChange">
                                <label id="labelInput" class="file-chip" for="input1"> {{ $t('_ajouter_') }} {{
                                    this.attachFiles }}</label>
                                <br>
                                <label v-if="this.attachFiles === 'Picture' && this.badFileFormat"
                                    style="color: red;">{{
                                        $t('_choisir_une_image_format_') }}</label>
                                <label v-else-if="this.badFileFormat" style="color: red;">{{
                                    $t('_choisir_un_fichier_csv_') }}</label>
                                <span id="oldFileName" v-for="(file, index) in this.oldFileList" :key="index">
                                    {{ file.filename }}
                                    <a :href="file.url" :download="file.filename" class="download-icon"
                                        title="Télécharger"><v-icon style="width: 13px; height: 10px; color: black">
                                            mdi-download
                                        </v-icon></a>
                                    <br />
                                </span>
                                <span id="fileName" v-for="(file, index) in this.fileList" :key="index">
                                    {{ file.name }}
                                    <v-icon style="font-size: medium;" @click="remove(index)"> mdi-close</v-icon>
                                    <br />
                                </span>
                            </div>

                        </div>
                        <div class="conclusion justify-space-between">
                            <div v-for="(question, index) in this.alarm.field_conclusions" :key="index">
                                {{ index }}
                                <v-radio-group v-model="field_conclusions[index]">
                                    <v-radio v-for="(enonce, i) in question" :label="enonce" :value="enonce"
                                        :key="i"></v-radio>
                                </v-radio-group>
                            </div>

                        </div>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <v-btn style="float: right; background-color: #F49301; padding: 1.8vmax; font-size: 1.8vmax"
                                @click="submit()">
                                {{ $t('_soumettre_') }}
                            </v-btn>
                            <v-btn style="float: right; right: 1vw; padding: 1.8vmax; font-size: 1.8vmax;"
                                @click="save()">
                                {{ $t('_enregistrer_') }}
                            </v-btn>

                        </slot>
                    </div>
                    <PopUpSave v-if="modalState === true" @back="closeModal" @close="$emit('close')"></PopUpSave>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import PopUpSave from './PopUpSave.vue'
import backend from '@/api/backend'

export default {
    props: {
        alarm: {
            required: true,
        },
        answer: {
            required: false
        }
    },
    components: { PopUpSave },

    beforeMount() {
        const multipleChoices = this.alarm.progress_form['multiple Choice field']
        for (var key in multipleChoices) {
            this.$set(this.multipleChoiceQuestions, key, [])
        }
        for (var index in this.alarm.progress_form['open field (Number)']) {
            this.$set(this.validNumber, this.alarm.progress_form['open field (Number)'][index], true)
        }
        this.attachFiles = this.alarm.progress_form['attach File (s)'] === undefined ? '' : this.alarm.progress_form['attach File (s)']
    },

    async mounted() {
        let reponse
        await this.answer
        if (this.answer !== undefined) {
            this.checkBoxQuestions = this.answer.progress_form['check boxes']
            for (var question in this.answer.progress_form['multiple Choice field']) {
                this.multipleChoiceQuestions[question] = this.answer.progress_form['multiple Choice field'][question]
            }
            this.filename = this.answer.progress_form['attach File (s)']
            this.textField = this.answer.progress_form['open field (text)']
            this.numberField = this.answer.progress_form['open field (Number)']
            this.field_conclusions = this.answer.field_conclusions
        }
        try {
            reponse = (await backend.get_file_for_alarm(this.alarm.id))
            let file = { "filename": "", "url": "" }
            file.filename = reponse.headers['content-disposition'].split("'")[2]
            file.url = URL.createObjectURL(reponse.data);
            this.oldFileList.push(file)
            // }
        } catch (error) {
            console.error("pas de fichier à récupérer")
        }


    },

    data() {
        return {
            checkBoxQuestions: {},
            multipleChoiceQuestions: {},
            textField: {},
            numberField: {},
            validNumber: {},
            oldFileList: [],
            fileList: [],
            attachFiles: '',
            field_conclusions: {},
            updatedAnswer: {},
            modalState: false,
            badFileFormat: false,
            part: "",
        }

    },

    beforeDestroy (){
        for (let fichier in this.oldFileList){
            URL.revokeObjectURL(this.oldFileList[fichier].url)
        }
    },

    methods: {
        openModal() {
            this.modalState = true;
        },

        closeModal() {
            this.modalState = false;
        },

        handleFileChange(event) {
            const files = Array.from(event.target.files);
            for (var index in files) {
                if (this.attachFiles === 'Picture' && files[index].type === "") {
                    files[index].type === "image/jpg"
                }
                if (this.attachFiles === 'Picture' && files[index].name === "") {
                    files[index].name === "0.jpg"
                }
                if (this.attachFiles === 'Picture' && files[index].type.split('/')[0] !== 'image') {
                    this.badFileFormat = true
                    event.target.value = ""
                }
                else if (this.attachFiles !== 'Picture' && files[index].type !== "text/csv" && files[index].type !== "application/vnd.ms-excel") {
                    this.badFileFormat = true
                    event.target.value = ""
                }
                else if (this.fileList.indexOf(files[index]) === -1) {
                    this.badFileFormat = false
                    this.fileList.push(files[index])
                }
            }
        },
        remove(index) {
            this.fileList.splice(index, 1)
        },
        updateAnswer() {
            this.updatedAnswer['progress_form'] = {}
            this.updatedAnswer['progress_form']['check boxes'] = this.checkBoxQuestions
            this.updatedAnswer['progress_form']['multiple Choice field'] = this.multipleChoiceQuestions
            this.updatedAnswer['progress_form']['open field (text)'] = this.textField
            this.updatedAnswer['progress_form']['open field (Number)'] = this.numberField
            this.updatedAnswer['field_conclusions'] = this.field_conclusions
        },
        submit() {
            this.updateAnswer()
            this.$emit('submit', this.updatedAnswer, this.fileList)
        },
        save() {
            this.updateAnswer()
            this.$emit('save', this.updatedAnswer, this.fileList)
        }
    },

    watch: {
        numberField: {
            handler() {
                for (var key in this.numberField) {
                    const valueArray = this.numberField[key].split(".")
                    if (valueArray.length > 2) {
                        this.validNumber[key] = false
                    }
                    else {
                        this.validNumber[key] = true
                    }
                }
            },
            deep: true,
        },
    },

}

</script>

<style scoped>
.modal-container-form {
    width: 95vw;
    height: 60vh;
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    display: flex;
    flex-direction: column;
}

.modal-header {
    font-weight: bold;
    font-size: 3vmax;
    color: #212121;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-body {
    overflow-y: auto;
    overflow-x: hidden;
    flex-grow: 1;
    max-height: calc(60vh - 8.4vmax - 4vh);
    color: #000000
}

.modal-default-button {
    float: right;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal-footer {
    padding: 1vh 1vh;
    background-color: white;
    color: white;
    position: absolute;
    bottom: 0;
    right: 0;
}

.instructions {
    padding-top: 1vh;
    font-size: 2vmax;
}

.progress {
    padding-top: 1vh;
}

/* Tres laid mais pas trouve d'autre solution */
.progress .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 0px;
}

.progress .v-input--radio-group--column .v-input--radio-group__input {
    flex-direction: row;
}


.progress .v-input--selection-controls__input {
    position: relative;
    margin-right: 0;
}

.conclusion {
    padding-top: 2vmax;
    font-size: 2vmax;
    flex-wrap: nowrap;
    display: flex;
    margin-bottom: 20px;
}

.v-radio .v-icon {
    font-size: 2vmax;
    color: rgb(0, 0, 0);
}

.theme--light.v-label {
    color: rgb(0, 0, 0);
    margin-right: 2vmin;
    margin-left: 1vmin;
}

.v-label {
    font-size: 1.6vmax;
    color: black;
    left: 0.5vmax;
}

.v-input--selection-controls {
    margin-top: 1vh;
    margin-right: 0;
    padding-top: 0;
}

.v-input--selection-controls__ripple {
    border-radius: 50%;
    cursor: pointer;
    position: absolute;
    -webkit-transition: inherit;
    transition: inherit;
    height: fit-content;
    width: fit-content;
    left: 0;
    top: 0;
    margin: 0;
}

.download-icon {
    font-size: 18px;
    text-decoration: none;
    cursor: pointer;
}

/* .multipleChoices {
    display: flex;
    flex-direction: row;
} */

.multipleChoices .v-messages {
    min-height: 0px;
    min-width: 1px;
    position: relative;
}

.v-input__slot {
    margin-bottom: 0px;
}

.multipleChoices .v-icon {
    font-size: 2.3vmax;
}

.question {
    font-size: 2vmax;
    margin-bottom: 2vmax;
    margin-right: 2vw;
}

input[type="file"] {
    display: none;
}

.file-chip {
    padding-left: 1vmax;
    border-radius: 16px;
    background-color: #8096f6c5;
    color: black;
    font-size: 1.6vmax;
    cursor: pointer;
    transition: background-color 0.3s;
}

#fileName {
    background-color: #EAEAEA;
    font-size: 1.6vmax;
}

.textField {
    font-size: 2vmax;
}

.v-text-field--outlined .v-input__control .v-input__slot {
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    min-height: 2vmax;
    font-size: 1.8vmax;
}

.numberField {
    font-size: 2vmax;
}

.v-messages {
    min-height: 0;
    height: 0;
}

.v-text-field__details {
    margin: 0;
    min-height: 0;
}
</style>